import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { ArrowLeft, ExternalLink, MapPin, Users, Gift, Calendar, Mail, TrendingUp } from 'lucide-react';
import { partners } from '../utils/partnersData';
const PartnerDetail = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const partner = partners.find(p => p.id === parseInt(id || '0'));
  if (!partner) {
    return <div className="flex h-screen bg-gray-50" data-id="element-3268">
        <div className="w-20 flex-shrink-0" data-id="element-3269">
          <Sidebar data-id="element-3270" />
        </div>
        <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3271">
          <Topbar data-id="element-3272" />
          <main className="flex-1 overflow-y-auto p-6" data-id="element-3273">
            <div className="text-center py-12" data-id="element-3274">
              <h2 className="text-2xl font-semibold text-gray-700" data-id="element-3275">
                Partner non trovato
              </h2>
              <button onClick={() => navigate('/partners')} className="mt-4 text-green-600 hover:underline" data-id="element-3276">
                Torna ai Partners
              </button>
            </div>
          </main>
        </div>
      </div>;
  }
  return <div className="flex h-screen bg-gray-50" data-id="element-3277">
      <div className="w-20 flex-shrink-0" data-id="element-3278">
        <Sidebar data-id="element-3279" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3280">
        <Topbar data-id="element-3281" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-3282">
          {/* Back Button */}
          <button onClick={() => navigate('/partners')} className="flex items-center text-gray-600 hover:text-green-600 mb-4 transition-colors" data-id="element-3283">
            <ArrowLeft className="h-4 w-4 mr-2" data-id="element-3284" />
            Torna ai Partners
          </button>

          {/* Partner Header */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6" data-id="element-3285">
            <div className="flex flex-col md:flex-row md:items-start gap-6" data-id="element-3286">
              <div className="flex-shrink-0" data-id="element-3287">
                <img src={partner.logo} alt={partner.name} className="h-24 w-24 object-contain rounded-lg border border-gray-200 p-2 bg-white" onError={e => {
                e.currentTarget.src = 'https://via.placeholder.com/96?text=Logo';
              }} data-id="element-3288" />
              </div>

              <div className="flex-1" data-id="element-3289">
                <div className="flex items-start justify-between mb-2" data-id="element-3290">
                  <h1 className="text-3xl font-bold text-gray-900" data-id="element-3291">
                    {partner.name}
                  </h1>
                  <a href={partner.website} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-green-600 hover:text-green-700 transition-colors" data-id="element-3292">
                    <ExternalLink className="h-5 w-5" data-id="element-3293" />
                    <span className="text-sm font-medium" data-id="element-3294">Visita sito</span>
                  </a>
                </div>

                <p className="text-gray-600 mb-4" data-id="element-3295">{partner.description}</p>

                <div className="flex flex-wrap gap-2 mb-4" data-id="element-3296">
                  {partner.categories.map((category, index) => <span key={index} className="px-3 py-1 bg-green-600/10 text-green-600 text-sm font-medium rounded-full" data-id="element-3297">
                      {category}
                    </span>)}
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-3298">
                  <Calendar className="h-4 w-4" data-id="element-3299" />
                  <span data-id="element-3300">
                    Partner dal{' '}
                    {new Date(partner.joinedDate).toLocaleDateString('it-IT', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6" data-id="element-3301">
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-3302">
              <div className="flex items-center justify-between mb-2" data-id="element-3303">
                <MapPin className="h-5 w-5 text-gray-400" data-id="element-3304" />
              </div>
              <p className="text-2xl font-bold text-gray-900" data-id="element-3305">
                {partner.locations}
              </p>
              <p className="text-sm text-gray-600" data-id="element-3306">Sedi attive</p>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-3307">
              <div className="flex items-center justify-between mb-2" data-id="element-3308">
                <Gift className="h-5 w-5 text-gray-400" data-id="element-3309" />
              </div>
              <p className="text-2xl font-bold text-gray-900" data-id="element-3310">
                {partner.activeRewards}
              </p>
              <p className="text-sm text-gray-600" data-id="element-3311">Premi attivi</p>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-3312">
              <div className="flex items-center justify-between mb-2" data-id="element-3313">
                <TrendingUp className="h-5 w-5 text-gray-400" data-id="element-3314" />
              </div>
              <p className="text-2xl font-bold text-gray-900" data-id="element-3315">
                {partner.totalRedemptions?.toLocaleString('it-IT')}
              </p>
              <p className="text-sm text-gray-600" data-id="element-3316">Riscatti totali</p>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-3317">
              <div className="flex items-center justify-between mb-2" data-id="element-3318">
                <TrendingUp className="h-5 w-5 text-gray-400" data-id="element-3319" />
              </div>
              <p className="text-2xl font-bold text-gray-900" data-id="element-3320">
                {partner.conversionRate}%
              </p>
              <p className="text-sm text-gray-600" data-id="element-3321">Conversion rate</p>
            </div>
          </div>

          {/* Contact Actions */}
          <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3322">
            <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-3323">Azioni</h2>
            <div className="flex flex-wrap gap-3" data-id="element-3324">
              <button className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors" data-id="element-3325">
                <Mail className="h-4 w-4" data-id="element-3326" />
                Invia Email
              </button>
              <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-3327">
                Visualizza Report
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default PartnerDetail;